import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import TradingAcademy from "../pages/trading-academy/page";
import Advisory from "../pages/advisory/page";
import Partnerships from "../pages/partnerships/page";
import Contact from "../pages/contact/page";
import Leadership from "../pages/leadership/page";
import Insights from "../pages/insights/page";
import Admin from "../pages/admin/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/services", element: <Services /> },
  { path: "/trading-academy", element: <TradingAcademy /> },
  { path: "/advisory", element: <Advisory /> },
  { path: "/partnerships", element: <Partnerships /> },
  { path: "/contact", element: <Contact /> },
  { path: "/leadership", element: <Leadership /> },
  { path: "/insights", element: <Insights /> },
  { path: "/admin", element: <Admin /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
